export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const SET_ROLES = "SET_ROLES";
export const SET_ACCOUNT_DATA = "SET_ACCOUNT_DATA";
export const REGISTER_SUCCESS_MESSAGE = "REGISTER_SUCCESS_MESSAGE";

export const AUTH_UPDATE_STATE = "AUTH_UPDATE_STATE";